import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice, createSelector } from "@reduxjs/toolkit";
import { createSetQueryParamsReducer } from "./common";
import { StandardObject } from "utils";

interface ApplicationGroupState {
  queryParams: StandardObject;
  totalSize: number;
}

const initialState: ApplicationGroupState = {
  queryParams: {},
  totalSize: 0,
};

export const applicationGroupSlice = createSlice({
  name: "applicationGroup",
  initialState,
  reducers: {
    setQueryParams: createSetQueryParamsReducer("queryParams"),
    setTotalSize: (state, action: PayloadAction<number>) => {
      state.totalSize = action.payload;
    },
  },
});

const selectApplicationGroup = (state: {
  applicationGroup: ApplicationGroupState;
}) => state.applicationGroup;

export const selectApplicationGroupState = createSelector(
  [selectApplicationGroup],
  (s: ApplicationGroupState) => {
    return {
      queryParams: s.queryParams,
      totalSize: s.totalSize,
    };
  }
);

export const {
  setQueryParams,
  setTotalSize,
} = applicationGroupSlice.actions;

export default applicationGroupSlice.reducer;